
export interface NotifiedOperative {
  email?: string
}